import type { Resource } from '../../';
export const country_countries_CO: Resource = {"default":"Colombia"};
